export const OfferTag = () => {
  return <span className="tag green"> ¡Oferta! </span>;
};
